<template>
  <v-card color="white" class="rounded" elevation="1">
    <v-card-title>
      <h4 class="subheading">Ovations</h4>
      <span class="caption ml-2"> ({{ getMonthName(month) }} {{ year }})</span>
    </v-card-title>
    <v-card-text>
      <v-flex v-if="loading">
        <v-progress-circular
          :size="32"
          :width="4"
          color="#d13b55"
          indeterminate
        ></v-progress-circular>
      </v-flex>
      <div style="height: 300px" v-if="!loading && ovationsSummaryData">
        <v-layout row wrap pt-4>
          <v-flex md4>
            <div class="text-xs-center">
              <v-icon>mdi-plus-circle-outline</v-icon>
            </div>
            <div class="text-xs-center grey--text text--darken-1">Added</div>
            <div class="text-xs-center headline font-weight-bold">
              {{ ovationsSummaryData.added }}
            </div>
          </v-flex>
          <v-flex md4>
            <div class="text-xs-center">
              <v-icon>mdi-plus-circle-outline</v-icon>
            </div>
            <div class="text-xs-center grey--text text--darken-1">Assigned</div>
            <div class="text-xs-center headline font-weight-bold">
              {{ ovationsSummaryData.assigned }}
            </div>
          </v-flex>
          <v-flex md4>
            <div class="text-xs-center">
              <v-icon>mdi-plus-circle-outline</v-icon>
            </div>
            <div class="text-xs-center grey--text text--darken-1">Sent</div>
            <div class="text-xs-center headline font-weight-bold">
              {{ ovationsSummaryData.sent }}
            </div>
          </v-flex>
        </v-layout>
        <v-layout row wrap pt-4 pb-4>
          <v-flex></v-flex>
        </v-layout>
        <v-layout row wrap pt-4>
          <v-flex md4>
            <div class="text-xs-center">
              <v-icon>mdi-plus-circle-outline</v-icon>
            </div>
            <div class="text-xs-center grey--text text--darken-1">
              Auto-assigned
            </div>
            <div class="text-xs-center headline font-weight-bold">
              {{ ovationsSummaryData.autoAssigned }}
            </div>
          </v-flex>
          <v-flex md4>
            <div class="text-xs-center">
              <v-icon>mdi-plus-circle-outline</v-icon>
            </div>
            <div class="text-xs-center grey--text text--darken-1">Refunded</div>
            <div class="text-xs-center headline font-weight-bold">
              {{ ovationsSummaryData.refunded }}
            </div>
          </v-flex>
          <v-flex md4>
            <div class="text-xs-center">
              <v-icon>mdi-plus-circle-outline</v-icon>
            </div>
            <div class="text-xs-center grey--text text--darken-1">Redeemed</div>
            <div class="text-xs-center headline font-weight-bold">
              {{ ovationsSummaryData.redeemed }}
            </div>
          </v-flex>
        </v-layout>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "OvationsSummaryChart",
  props: ["ovationsSummaryData", "year", "month", "loading"],
  methods: {
    getMonthName(monthIndex) {
      var monthName = "All of";
      switch (monthIndex) {
        case "-1":
          monthName = "All of";
          break;
        case "1":
          monthName = "Jan";
          break;
        case "2":
          monthName = "Feb";
          break;
        case "3":
          monthName = "Mar";
          break;
        case "4":
          monthName = "Apr";
          break;
        case "5":
          monthName = "May";
          break;
        case "6":
          monthName = "Jun";
          break;
        case "7":
          monthName = "Jul";
          break;
        case "8":
          monthName = "Aug";
          break;
        case "9":
          monthName = "Sep";
          break;
        case "10":
          monthName = "Oct";
          break;
        case "11":
          monthName = "Nov";
          break;
        case "12":
          monthName = "Dec";
          break;
      }
      return monthName;
    },
  },
};
</script>

<style>
</style>